import { authScope, readRefreshToken } from "../axios_Interceptor/authSession";
import axios from "axios";

import url from "../server";

import { createContext, ReactNode, useContext } from "react";

import api, { logout as clearSessionAndRedirect } from "../axios_Interceptor/api";


interface TokenProviderProps {

  children: ReactNode;

}

interface UserinfoType {

  exp: number;

  iat: number;

  nickname: string;

  user_level: string;

  userid: string;

}

interface TokenContextType {

  userinfoReturn: () => Promise<UserinfoType>;

  logout: (isAdmin?: string) => void;

}



const TokenContext = createContext<TokenContextType | null>(null);



export const useToken = () => {

  const context = useContext(TokenContext);

  if (!context) {

    throw new Error("최상위에서 <TokenProvider>를 반드시 포함해야합니다");

  }

  return context;

};



export function TokenProvider({ children }: TokenProviderProps) {

  const userinfoReturn = async (): Promise<UserinfoType> => {

    const res = await api.get(url.Communication_url.user_info);

    return res.data;

  };



  const logout = async (isAmdin?: string) => {

    try { await axios.post(url.Communication_url.logout, { refreshToken: readRefreshToken() }, { withCredentials: true, headers: { "X-Fanbird-Session": authScope() } }); }

    catch { alert("로그아웃 요청에 실패했습니다. 다시 시도해주세요."); return; }

    clearSessionAndRedirect(isAmdin);
  };



  const contextValue: TokenContextType = {

    logout,

    userinfoReturn,

  };



  return (

    <TokenContext.Provider value={contextValue}>

      {children}

    </TokenContext.Provider>

  );

}

